(function() {
  const accordionTrigger = qsa('.js-product-information__title');
  const isCollapse = 'product-information__content--collapse';

  const info_items = qsa('.js-product-information__item');
  if(info_items.length > 0) {
    qs('.js-product-information__title', info_items[0]).classList.add(isCollapse);
    const content_el = qs('.js-product-information__content', info_items[0]);
    if(content_el) {
      content_el.style.height = `${content_el.scrollHeight}px`;
    }
  }

  accordionTrigger.forEach((item) => {
    item.addEventListener('click', (e) => {
      const parent = e.currentTarget.closest('.js-product-information__item');
      const content = parent.querySelector('.js-product-information__content');   
      
      if (e.currentTarget.classList.contains(isCollapse)) {
        e.currentTarget.classList.remove(isCollapse)
        if(content) {
          content.style.height = '0';
        }
      
      } else {    
        e.currentTarget.classList.add(isCollapse);
        if(content) {
          content.style.height = `${content.scrollHeight}px`;
        }
      }      
    });
  });
})();